import styled, { keyframes } from "styled-components";
import { zoomIn } from "react-animations";
import { SocialIcon } from "react-social-icons";
import { fadeInDownBig } from "react-animations";

const zoomAnimation = keyframes`${zoomIn}`;
const speedInAnimation = keyframes`${fadeInDownBig}`;
const Content = styled.div`
  animation: 2s ${zoomAnimation};
  width: 60%;
  padding: 20px;
  margin: 6% auto;
  background-color: rgba(0, 0, 0, 0.8);
  border-radius: 20px;
  box-shadow: 0 0 5px 5px #b026ff;
  color: white;
  font-family: "Comic Neue", cursive;
  text-align: center;
  & > h1 {
    width: 80%;
    margin: auto;
    margin-bottom: 2.5%;
    padding-bottom: 10px;
    border-bottom: 4px solid #b026ff;
  }
  & > div:nth-child(2) {
    margin: auto;
    width: 80%;
    text-align: justify;
  }
  & > div:nth-child(2) > p {
    font-weight: bold;
    line-height: 25px;
    font-size: 20px;
    margin-bottom: 2.5%;
    padding-bottom: 2.5%;
    border-bottom: 4px solid #b026ff;
  }
  @media screen and (max-width: 768px) {
    animation: 2s ${zoomAnimation};
    width: 88%;
    padding: 10px;
    margin: 10% auto;
    background-color: rgba(0, 0, 0, 0.8);
    border-radius: 10px;
    box-shadow: 0 0 5px 5px #b026ff;
    color: white;
    font-family: "Comic Neue", cursive;
    text-align: center;
    & > div:nth-child(2) {
      margin: auto;
      width: 100%;
      text-align: justify;
    }
  } ;
`;
const Social = styled.div`
  animation: 2s ${speedInAnimation};
  margin: 1% auto;
  width: 30%;
  display: flex;
  align-items: center;
  justify-content: space-around;

  @media screen and (max-width: 768px) {
    animation: 2s ${speedInAnimation};
    margin: 10% auto;
    width: 95%;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
`;
export const Contact = () => {
  return (
    <>
      <Content>
        <h1>GET IN TOUCH</h1>
        <div>
          <p>
            Socializing and Connecting is really important, which leads to great
            ideas and major breakthroughs. If you have any ground breaking idea
            or have some interesting work, then I can help you with bringing
            that idea to life as developing awesome web apps happens to be my
            key skill. So, just don't wait or hesitate, connect with me and we
            can start working on that great idea of yours.
          </p>
          <p>Connect with me @ +91 9868551551.</p>
        </div>
      </Content>
      <Social>
        <SocialIcon
          url="https://www.linkedin.com/in/pulkit-tyagi-3051b8127/"
          target="_blank"
          style={{ height: 70, width: 70 }}
          bgColor="#000000"
          fgColor="#ffffff"
        />
        <SocialIcon
          url="https://github.com/Pulkit0111"
          target="_blank"
          style={{ height: 70, width: 70 }}
          bgColor="#000000"
          fgColor="#ffffff"
        />
        <SocialIcon
          url="https://twitter.com/1994_TJAY"
          target="_blank"
          style={{ height: 70, width: 70 }}
          bgColor="#000000"
          fgColor="#ffffff"
        />
        <SocialIcon
          url="https://tyagi0111.medium.com/"
          target="_blank"
          style={{ height: 70, width: 70 }}
          bgColor="#000000"
          fgColor="#ffffff"
        />
        <SocialIcon
          url="mailto: ptyagi1551@gamil.com"
          target="_blank"
          style={{ height: 70, width: 70 }}
          bgColor="#000000"
          fgColor="#ffffff"
        />
      </Social>
    </>
  );
};
